import { useEffect } from "react";

import FieldGuide from "./FieldGuide";

/**
 * Canonical Help route.
 *
 * The app already has a full static Field Guide implementation.
 * We keep `/help/field-guide` for backward compatibility, and render the same
 * content at `/help` as the canonical route.
 */
export default function Help() {
  // Ensure scroll-to-top so users don't land mid-page.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <FieldGuide />;
}
